/*
 * start.tsx contains all code that should only run in prod/qa, and renders the app to the dom.
 * For code that should run in test + prod, see App.tsx
 * For global-unit-test-only see utils/test/specs.js
 * For individual-unit-test-only see utils/test/render.js
 */

import { renderRoot } from 'quartz-core/client';
import { App } from './App';
import ApplicationContainer from './containers/ApplicationContainer';
import PreviewContainer from './containers/PreviewContainer';
import IframeableContainer from './containers/IframeableContainer';
import 'I18n/init/data/currency';

// Rhumb and Routing
import { createBrowserHistory } from 'history';
import { Switch, Route } from 'react-router-dom';
import Raven from 'raven-js';
import { getLangPromise } from './utils/locale';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
getLangPromise().then(() => {
  renderRoot( /*#__PURE__*/_jsx(App, {
    history: createBrowserHistory({
      basename: `/payments/`
    }),
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/iframe/preview",
        children: /*#__PURE__*/_jsx(IframeableContainer, {
          children: /*#__PURE__*/_jsx(PreviewContainer, {
            children: /*#__PURE__*/_jsx(ApplicationContainer, {})
          })
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/iframe",
        children: /*#__PURE__*/_jsx(IframeableContainer, {
          children: /*#__PURE__*/_jsx(ApplicationContainer, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/",
        component: ApplicationContainer
      })]
    })
  }));
}).catch(err => Raven.captureException(err));